// src/pages/ProfilePage.jsx
import React, { useState } from 'react';
import { User, Mail, Lock, FileSignature } from 'lucide-react';
import ProfileHeader from './modules/ProfileHeader';
import ProfilePictureUpload from './modules/ProfilePicUpload';
import PersonalInfoForm from './modules/PersonalInfoForm';
import PasswordChangeForm from './modules/PasswordChange';
import SignatureUpload from './modules/SignatureUpload';
import { useNavigate } from 'react-router-dom';
import Button from '../../utils/Button';
const ProfilePage = () => {
    const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('personal');
  const [profileData, setProfileData] = useState({
    name: 'John Doe',
    email: 'john.doe@company.com',
    phone: '+1 (555) 123-4567',
    department: 'Human Resources',
    position: 'HR Manager',
    employeeId: 'EMP-2023-001',
    joinDate: '2023-01-15'
  });

  const handleProfileUpdate = (updatedData) => {
    setProfileData(prev => ({ ...prev, ...updatedData }));
  };
  const tabs = [
    { id: 'personal', label: 'Personal Info', icon: User },
    { id: 'security', label: 'Security', icon: Lock },
    { id: 'signature', label: 'Signature', icon: FileSignature },
    { id: 'dashboard', label: 'Dashboard', icon: User },
  ];

    return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Profile Settings</h1>
          <p className="text-gray-600 mt-2">Manage your account information and preferences</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Left Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 sticky top-6">
              <ProfileHeader 
                name={profileData.name}
                position={profileData.position}
                employeeId={profileData.employeeId}
              />
              
              <ProfilePictureUpload 
                currentImage="https://api.dicebear.com/7.x/avataaars/svg?seed=John"
                onImageChange={(newImage) => console.log('New image:', newImage)}
              />

              {/* Navigation Tabs */}
              <div className="mt-8 space-y-1">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                      activeTab === tab.id
                        ? 'bg-blue-50 text-blue-600 border border-blue-200'
                        : 'text-gray-600 hover:bg-gray-50'
                    }`}
                  >
                    <tab.icon className="h-5 w-5" />
                    <span className="font-medium">{tab.label}</span>
                  </button>
                ))}
              </div>

              {/* Account Status */}
              <div className="mt-8 pt-6 border-t border-gray-200">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm text-gray-600">Account Status</span>
                  <span className="px-2 py-1 bg-green-100 text-green-800 text-xs font-medium rounded-full">
                    Active
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-600">Member Since</span>
                  <span className="text-sm font-medium">{profileData.joinDate}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content Area */}
          <div className="lg:col-span-2 space-y-6">
            {activeTab === 'personal' && (
              <PersonalInfoForm 
                initialData={profileData}
                onUpdate={handleProfileUpdate}
              />
            )}

            {activeTab === 'security' && (
              <PasswordChangeForm 
                onPasswordChange={(newPassword) => console.log('Password changed to:', newPassword)}
              />
            )}

            {activeTab === 'signature' && (
              <SignatureUpload 
                currentSignature="https://via.placeholder.com/400x150?text=Signature+Placeholder"
                onSignatureChange={(newSignature) => console.log('New signature:', newSignature)}
              />
            )}
           
           {activeTab === 'dashboard' && (
            <>
            <Button onClick={() => navigate('/hr/dashboard')}>
  Go to Dashboard
</Button>
            </>
           )}

            {/* Additional Info Card */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Additional Information</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-500">Employee ID</label>
                    <p className="mt-1 text-gray-900">{profileData.employeeId}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-500">Department</label>
                    <p className="mt-1 text-gray-900">{profileData.department}</p>
                  </div>
                </div>
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-500">Position</label>
                    <p className="mt-1 text-gray-900">{profileData.position}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-500">Email Verified</label>
                    <div className="mt-1 flex items-center">
                      <div className="h-2 w-2 bg-green-500 rounded-full mr-2"></div>
                      <span className="text-green-700 text-sm font-medium">Verified</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;